/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkspaceDetails {
    getFixupPrototypeFunction() { return WorkspaceDetails.fixupPrototype; }

    static newInstance(model: Partial<WorkspaceDetails>): WorkspaceDetails {
        let obj = Object.assign(new WorkspaceDetails(), model);
        WorkspaceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkspaceDetails>): WorkspaceDetails {
        if (!model) return null;
        return WorkspaceDetails.newInstance(<WorkspaceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkspaceDetails) {
        if (!obj) return;

        models.WorkspaceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkspaceDetails): boolean {
        Object.setPrototypeOf(obj, WorkspaceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * resource id of the workspace
     */
    resource_id: string;

    /**
     * id of the workspace
     */
    workspace_id: string;

}
